<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div class="flex justify-between">
        <el-form ref="elFormDom" inline :model="table.params" size="small">
          <el-form-item label="用户名称" prop="name">
            <el-input
              clearable
              v-model="table.params.name"
              placeholder="请输入用户名称"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <el-input
              clearable
              v-model="table.params.account"
              placeholder="请输入账号"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          <div class="t">
            <span class="m">邀新活动</span>
            <el-switch
              @change="change"
              v-model="share_open_status"
              active-color="#13ce66"
              active-value="1"
              inactive-value="2"
            >
            </el-switch>
          </div>
          <div class="t" @click="handdialog">
            邀新奖励会员天数
            <el-link type="success">{{ share_days }}天</el-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        indexLabel="序号"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:action="{ row }">
          <el-button type="text" @click="showDetails(row)">查看</el-button>
        </template>
      </VTable>
    </div>

    <detail ref="detail" @refresh="getTable"></detail>
    <el-dialog
      title="邀新奖励老用户"
      :visible.sync="dialogFormVisible"
      width="500px"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="会员天数">
          <el-input v-model="day" clearable
            ><template slot="append">天</template></el-input
          >
        </el-form-item>
        <el-form-item label="奖励规则"> </el-form-item>
        <el-form-item label="" label-width="10px">
          1、用户邀请新人注册可免费获赠会员体验，具体获赠天数以邀请时设置的天数为准<br />
          2、会员有效期内邀请成功获得体验天数自动累加
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setShareDays">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import detail from "./components/detail.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "ReportList",
  mixins: [mixinTable],
  components: {
    VTable,
    detail,
  },
  data() {
    return {
      field: [
        { name: "nickname", label: "用户名称", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "share_vip_times", label: "邀请人数", hidden: false },
        { name: "share_days", label: "获赠会员(天)", hidden: false },
        {
          name: "share_lastly_time",
          label: "更新时间",
          hidden: false,
        },
        { name: "action", label: "操作", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          name: "",
          account: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      share_open_status: 2,
      share_days: "",
      dialogFormVisible: false,
      day: "",
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/user/shareList", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.share_open_status = res.data.share_open_status;
            this.share_days = res.data.share_days;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 重置查询条件
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    change() {
      this.$http
        .post("/admin/user/setShareStatus", {
          open_status: this.share_open_status,
        })
        .then((res) => {});
    },
    setShareDays() {
      if (!this.day) return this.$message.error("天数不能为空");
      this.$http
        .post("/admin/user/setShareDays", {
          days: this.day,
        })
        .then((res) => {
          this.dialogFormVisible = false;
          this.share_days = this.day;
          this.$message.success("设置成功");
        });
    },
    handdialog() {
      this.day = this.share_days;
      this.dialogFormVisible = true;
    },
    // 创建、编辑
    showDetails(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      if (!!row.id) {
        dom.getDetail(row);
      }
      dom = null;
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.t {
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
}
.justify-between {
  justify-content: space-between;
}
.m {
  margin: 0 5px 0 35px;
}
</style>